import styles from './GenderAgeDetails.module.scss'
const GraphCountTable = ({ data }) => {
  
  return <td>{data[0]<=-1?0:data[0]}</td>
}
const getGenderAgeDetails = ({ data }) => {
  let arr_male=[]
  let arr_female=[]
 

    for(let i=0;i<data[0].length;i++)
    {
      let mar=[],far=[]
      mar.push(data[0][i].male_count)
      arr_male.push(mar)

      far.push(data[0][i].female_count)
      arr_female.push(far)
    }
  
  if (data !== null && data !== undefined) {
    return (
      <div className={styles.maindivFormat}>
      <table>
        <thead>
          <tr>
            <th>Gender</th>
            {data[0].map((data_val) => {
              return <th>{data_val.age_bucket_display}</th>}
              )}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Male</td>
            {arr_male.map((data_val)=>{
              return <GraphCountTable data={data_val} isMale={true}/>}
              )}
          </tr>
          <tr>
            <td>Female</td>
            {arr_female.map((data_val)=>{
              return <GraphCountTable data={data_val} isMale={true} />}
              )}
          </tr>
        </tbody>
      </table>
      </div>
    )
  } else {
    return <div></div>
  }
}

export default getGenderAgeDetails
